import { withMetadata } from '@pf/shared-utility';
import { UserFragment } from '@control-tower/platform-loads';

export interface IUserFragment {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
}

export const UserFragmentSymbol = 'UserFragment';

export function withUserFragmentMetadata() {
    withMetadata<UserFragment>(UserFragmentSymbol, {
        id: String,
        firstName: String,
        lastName: String,
        email: String,
    });
}
